import IndexPage from './module/index';
import TabSwitch from './module/tabswitch';
import Footer from './module/footer';
import Jigou from './module/jigou';
import FeedbackPage from './module/feedback';
import Search from './module/search';
import Filter from './module/filter';

import 'jquery';
import 'bootstrap'

class Init {
    private page: any;

    constructor(){
        this.page= 1;
    }

    public exec (el:any,that:any,fn:any): void {
        if ($(el).length && (typeof fn) === 'function') {
            fn.call(that, el);
        }
    }
}

const init = new Init();

// Instantiation Class
const pIndex = new IndexPage();
const tabswitch = new TabSwitch();
const footer = new Footer();
const jigou = new Jigou();
const feedback = new FeedbackPage();
const search = new Search();
const filter = new Filter();

// console.log('init js.')

init.exec('.p-index',pIndex,pIndex.init);
init.exec('.tab-box',tabswitch,tabswitch.init);
init.exec('.footer',footer,footer.init);
init.exec('.p-fankui',feedback,feedback.init);
init.exec('.p-search',search,search.init);
init.exec('.filter-box',filter,filter.init);
init.exec('.btn-see-all',jigou,jigou.viewDesc);
